import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()

export class LoginRedirectService {

	constructor(private router: Router) { }

	private redirectPoint: string;
	private isClickedMyPapers: boolean = false;
	private clickedPaper: boolean = false;


	setRedirectPaper(clickedPaper) {
		this.clickedPaper = clickedPaper;
	}

	getRedirectPaper() {
		return this.clickedPaper;
	}
	
	setRedirectPoint(redirectPoint) {
		this.redirectPoint = redirectPoint;
	}

	getRedirectPoint() {
		return this.redirectPoint;
	}

	cickedMyPapers(value) {
		this.isClickedMyPapers = value;
	}

	getIsClickedMyPapers() {
		return this.isClickedMyPapers;
	}
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/services/login-redirect.service.ts